(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_section-flex-pdp-quantity-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var FLAG = 'hcDtoSent';

    function closeModal() {
      var m = document.getElementById('hc-dto-modal');
      if (m) m.remove();
      document.documentElement.classList.remove('hc-dto-lock');
    }

    function openModal(tpl) {
      if (!tpl) return;
      closeModal();
      var m = document.createElement('div');
      m.id = 'hc-dto-modal';
      m.className = 'hc-dto-modal';
      m.setAttribute('role', 'dialog');
      m.setAttribute('aria-modal', 'true');
      m.appendChild(tpl.content.cloneNode(true));
      document.body.appendChild(m);
      document.documentElement.classList.add('hc-dto-lock');
      var first = m.querySelector('input:not([type="hidden"]):not([readonly])') || m.querySelector('[data-hc-dto-close]');
      if (first) first.focus();
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var opener = e.target.closest('[data-hc-dto-open]');
      if (opener) {
        e.preventDefault();
        var wrap = opener.closest('[data-hc-dto]');
        openModal(wrap && wrap.querySelector('template[data-hc-dto-tpl]'));
        return;
      }
      if (e.target.closest('[data-hc-dto-close]') || e.target.id === 'hc-dto-modal') closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    document.addEventListener('submit', function (e) {
      if (e.target.closest && e.target.closest('#hc-dto-modal')) {
        try { sessionStorage.setItem(FLAG, '1'); } catch (err) {}
      }
    }, true);

    /* Keep the price beside the quantity box when the label line wraps onto two lines */
    function align() {
      document.querySelectorAll('.shopify-block[id$="__quantity_picker"]').forEach(function (q) {
        if (!q.querySelector('[data-hc-dto]')) return;
        var p = q.previousElementSibling;
        if (!p || !/__price$/.test(p.id) || !p.firstElementChild) return;
        var box = q.querySelector('input');
        if (!box) return;
        var offset = Math.round(box.getBoundingClientRect().top - p.getBoundingClientRect().top);
        p.firstElementChild.style.transform = 'translateY(' + offset + 'px)';
      });
    }

    /* After the request is sent the page reloads: reopen the pop up to show the thank you */
    function reopenAfterSend() {
      var sent = false;
      try { sent = sessionStorage.getItem(FLAG) === '1'; } catch (err) {}
      if (!sent) return;
      var tpl = document.querySelector('template[data-hc-dto-tpl]');
      if (tpl && tpl.content.querySelector('[data-hc-dto-state]')) {
        openModal(tpl);
        if (tpl.content.querySelector('[data-hc-dto-state="success"]')) {
          try { sessionStorage.removeItem(FLAG); } catch (err) {}
        }
      }
    }

    function start() {
      align();
      reopenAfterSend();
      document.querySelectorAll('product-hot-reload').forEach(function (el) {
        new MutationObserver(function () { closeModal(); align(); }).observe(el, { childList: true, subtree: true });
      });
      window.addEventListener('resize', align);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(align);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["section-flex-pdp-dto-availability"] && !Shopify.designMode) return;
  try {
    (function () {
    function parisToday() {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date())
        .forEach(function (x) { p[x.type] = x.value; });
      return new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
    }
    function isoWeek(dt) {
      var d = new Date(dt.getTime());
      var n = (d.getUTCDay() + 6) % 7;
      d.setUTCDate(d.getUTCDate() - n + 3);
      var firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
      return 1 + Math.round(((d - firstThursday) / 86400000 - 3 + ((firstThursday.getUTCDay() + 6) % 7)) / 7);
    }
    function addDays(dt, days) {
      var d = new Date(dt.getTime());
      d.setUTCDate(d.getUTCDate() + days);
      return d;
    }
    function fill() {
      var today = parisToday();
      var monday = addDays(today, -((today.getUTCDay() + 6) % 7));
      var dyeMonday = addDays(monday, 7);
      var shipMonday = addDays(monday, 14);
      var shipFriday = addDays(monday, 18);
      var lang = (document.documentElement.lang || 'en').slice(0, 2) === 'fr' ? 'fr-FR' : 'en-GB';
      var fmt = new Intl.DateTimeFormat(lang, { timeZone: 'UTC', day: 'numeric', month: 'long' });
      document.querySelectorAll('[data-dto-availability]').forEach(function (el) {
        var t = el.getAttribute('data-template');
        if (!t) return;
        el.textContent = t
          .replace('[dye_week]', isoWeek(dyeMonday))
          .replace('[ship_week]', isoWeek(shipMonday))
          .replace('[ship_start]', fmt.format(shipMonday))
          .replace('[ship_end]', fmt.format(shipFriday));
      });
    }
    function start() {
      fill();
      document.querySelectorAll('product-hot-reload').forEach(function (el) {
        new MutationObserver(fill).observe(el, { childList: true });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["section-flex-pdp-dto-pause"] && !Shopify.designMode) return;
  try {
    (function () {
    function place() {
      var fresh = document.querySelector('product-hot-reload [data-dto-pause]');
      if (fresh) {
        document.querySelectorAll('body > [data-dto-pause]').forEach(function (el) { el.remove(); });
        document.body.appendChild(fresh);
      }
      if (document.querySelector('[data-dto-pause]')) {
        document.querySelectorAll('product-hot-reload form[action*="/cart/add"] [type="submit"]').forEach(function (b) {
          b.disabled = true;
        });
      }
    }
    function start() {
      place();
      document.querySelectorAll('product-hot-reload').forEach(function (el) {
        new MutationObserver(place).observe(el, { childList: true });
      });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-dto-pause-close]')) {
        document.documentElement.classList.add('dto-pause-dismissed');
      }
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["section-flex-pdp-dto-photo-note"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.hcPhotoNoteReady) return;
    window.hcPhotoNoteReady = true;

    var queued = false;

    function place() {
      queued = false;
      var src = document.querySelector('[data-hc-photo-note-src] [data-hc-photo-note]');
      var main = document.querySelector('media-gallery .media-gallery__main');
      document.querySelectorAll('.media-gallery__main > [data-hc-photo-note]').forEach(function (old) {
        if (!src || old.parentNode !== main) old.remove();
      });
      if (!src || !main) return;
      if (main.querySelector(':scope > [data-hc-photo-note]')) return;
      main.appendChild(src.cloneNode(true));
    }

    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(place);
    }

    function closeAll(except) {
      document.querySelectorAll('.media-gallery__main > [data-hc-photo-note].is-open').forEach(function (n) {
        if (n === except) return;
        n.classList.remove('is-open');
        var b = n.querySelector('.hc-photo-note__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    var sheet = null;

    function useSheet() {
      return window.matchMedia('(max-width: 768px), (hover: none)').matches;
    }

    function closeSheet() {
      if (sheet) sheet.hidden = true;
    }

    function openSheet(note) {
      if (!sheet) {
        sheet = document.createElement('div');
        sheet.className = 'hc-photo-note-sheet';
        sheet.hidden = true;
        sheet.innerHTML = '<div class="hc-photo-note__panel is-sheet" role="dialog" aria-modal="true"><button type="button" class="hc-photo-note-sheet__close" aria-label="Close">×</button><div data-sheet-body></div></div>';
        document.body.appendChild(sheet);
        sheet.addEventListener('click', function (e) {
          if (e.target === sheet || (e.target.closest && e.target.closest('.hc-photo-note-sheet__close'))) closeSheet();
        });
      }
      var panel = note.querySelector('.hc-photo-note__panel');
      sheet.querySelector('[data-sheet-body]').innerHTML = panel ? panel.innerHTML : '';
      sheet.hidden = false;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.hc-photo-note__btn');
      if (btn && useSheet()) {
        openSheet(btn.closest('[data-hc-photo-note]'));
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (btn) {
        var note = btn.closest('[data-hc-photo-note]');
        var open = !note.classList.contains('is-open');
        closeAll(note);
        note.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (!(e.target.closest && e.target.closest('.hc-photo-note__panel'))) closeAll(null);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAll(null);
        closeSheet();
      }
    });

    function start() {
      place();
      new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', queue);
    document.addEventListener('shopify:block:select', queue);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["section-flex-pdp-palette-button"] && !Shopify.designMode) return;
  try {
    (function () {
    /* H&C palette store, shared by the palette button, the floating tab and the palette page.
       Saved in this browser only (localStorage). Each item: id (variant), h (product handle), q (skeins), t (thumbnail). */
    window.HCPalette = window.HCPalette || (function () {
      var KEY = 'hcPalette';
      var mem = [];
      function read() {
        try {
          var a = JSON.parse(localStorage.getItem(KEY) || '[]');
          if (Array.isArray(a)) return a;
        } catch (e) {}
        return mem.slice();
      }
      function fire() {
        document.dispatchEvent(new CustomEvent('hc:palette'));
      }
      function write(a) {
        mem = a.slice();
        try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
        fire();
      }
      function idx(a, id) {
        id = String(id);
        for (var i = 0; i < a.length; i++) if (String(a[i].id) === id) return i;
        return -1;
      }
      window.addEventListener('storage', function (e) { if (e.key === KEY) fire(); });
      return {
        list: read,
        count: function () {
          return read().reduce(function (n, x) { return n + (Number(x.q) || 0); }, 0);
        },
        get: function (id) {
          var a = read();
          var i = idx(a, id);
          return i > -1 ? a[i] : null;
        },
        add: function (item) {
          var a = read();
          var i = idx(a, item.id);
          if (i > -1) {
            for (var k in item) if (item[k] !== undefined && item[k] !== '') a[i][k] = item[k];
          } else {
            a.push(item);
          }
          write(a);
        },
        remove: function (id) {
          var a = read();
          var i = idx(a, id);
          if (i > -1) { a.splice(i, 1); write(a); }
        },
        setQty: function (id, q) {
          var a = read();
          var i = idx(a, id);
          if (i > -1) { a[i].q = Math.max(1, Number(q) || 1); write(a); }
        },
        merge: function (items) {
          var a = read();
          items.forEach(function (it) {
            var i = idx(a, it.id);
            if (i > -1) a[i].q = it.q; else a.push(it);
          });
          write(a);
        },
        clear: function () { write([]); },
        root: function () {
          var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          return r.charAt(r.length - 1) === '/' ? r : r + '/';
        }
      };
    })();

    function current(wrap) {
      var scope = wrap.closest('product-hot-reload') || wrap.closest('.shopify-section') || document;
      var idInput = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      var qtyInput = scope.querySelector('input[name="quantity"]');
      var id = (idInput && idInput.value) || wrap.dataset.id;
      var q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      return { id: id, q: q };
    }

    function refresh() {
      document.querySelectorAll('[data-hc-pal-btn]').forEach(function (wrap) {
        var cur = current(wrap);
        var item = window.HCPalette.get(cur.id);
        var btn = wrap.querySelector('[data-hc-pal-toggle]');
        var view = wrap.querySelector('[data-hc-pal-view]');
        var label = item ? wrap.dataset.in.replace('[n]', item.q) : wrap.dataset.add;
        if (wrap.classList.contains('is-in') !== !!item) wrap.classList.toggle('is-in', !!item);
        /* Only touch the text when it changes, so the page watcher below doesn't loop */
        if (btn && btn.textContent !== label) btn.textContent = label;
        var hide = window.HCPalette.list().length === 0;
        if (view && view.hidden !== hide) view.hidden = hide;
      });
    }

    var queued = false;
    function queueRefresh() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; refresh(); });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-hc-pal-toggle]');
      if (!btn) return;
      var wrap = btn.closest('[data-hc-pal-btn]');
      var cur = current(wrap);
      if (window.HCPalette.get(cur.id)) {
        window.HCPalette.remove(cur.id);
      } else {
        window.HCPalette.add({
          id: String(cur.id),
          h: wrap.dataset.handle,
          q: cur.q,
          t: String(cur.id) === String(wrap.dataset.id) ? wrap.dataset.thumb : ''
        });
      }
    });

    document.addEventListener('hc:palette', refresh);

    function start() {
      refresh();
      document.querySelectorAll('product-hot-reload').forEach(function (el) {
        new MutationObserver(queueRefresh).observe(el, { childList: true, subtree: true });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
